import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import find from 'lodash/find';

import { Alert, FormGroup, ControlLabel, ProgressBar, FormControl, ListGroup, ListGroupItem } from 'react-bootstrap';
import GetToken from './GetToken';
import CardForm from './CardForm';
import IconButton from './IconButton';

const Wrapper = styled.main`
  .alert-success {
    position: fixed;
    top: 2rem;
    right: 2rem;
    width: 20rem;
  }
  
  code {
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
  dl {
    display: flex;
    margin-bottom: 0;
  }
  dt {
    padding-right: 1rem;
    flex-basis: 5rem;
  }
  @media (min-width: 480px) {
    dt {
      text-align: right;
      flex-basis: 10rem;
    }
    .form-group.form-group {
      display: flex;
      align-items: flex-start;
      & > label {
        flex: 0 0 10rem;
        text-align: right;
        padding-right: 1rem;
        line-height: 34px;
        margin-bottom: 0;
      } 
    }
    .submit-group {
      padding-left 10rem; 
    }
  }
`;

class Main extends React.Component {
  getOptionName = this.getOptionName.bind(this);

  getOptionName(key) {
    const { storage, options } = this.props;
    const list = options[key];
    const id = storage[key];
    const item = find(list, { id });
    return item && item.name;
  }

  handleUpdate = this.handleUpdate.bind(this);

  handleUpdate(key) {
    const { onUpdate } = this.props;
    return (ev) => onUpdate({ [key]: ev.target.value });
  }

  warning = (text) => <Alert bsStyle="warning">{text}</Alert>;

  checks = this.checks.bind(this)

  checks() {
    const { storage, options } = this.props;
    if (!options.board || options.board.length === 0) {
      return this.warning('No board found');
    }
    if (storage.board && (!options.list || options.list.length === 0)) {
      return this.warning('No lists found');
    }
    return null;
  }

  forgetList = this.forgetList.bind(this);
  forgetList() {
    const { onUpdate } = this.props;
    return onUpdate({ list: undefined });
  }

  renderSelect = this.renderSelect.bind(this);

  renderSelect(key) {
    const { storage, options } = this.props;
    return (
      <FormGroup controlId={`get-${key}`}>
        <ControlLabel>Select {key}</ControlLabel>
        <FormControl
          componentClass="select"
          placeholder="select"
          value={storage[key]}
          required
          onChange={this.handleUpdate(key)}
        >
          <option>-- Please select --</option>
          {options[key].map((option) => <option key={option.id} value={option.id}>{option.name}</option>)}
        </FormControl>
      </FormGroup>
    );
  }

  renderSelectBlock = this.renderSelectBlock.bind(this);

  renderSelectBlock() {
    const {
      options, status,
    } = this.props;
    return (
      <React.Fragment>
        {options.board && this.renderSelect('board')}
        {options.list && this.renderSelect('list')}
        {status.loading ? <ProgressBar className="spinner" active now={100} /> : this.checks()}
      </React.Fragment>
    );
  }

  renderFormBlock = this.renderFormBlock.bind(this);

  renderFormBlock() {
    return (
      <React.Fragment>
        <IconButton icon="pencil2" className="pull-right" onClick={this.forgetList} />
        <dl><dt>Board</dt><dd>{this.getOptionName('board')}</dd></dl>
        <dl><dt>List</dt><dd>{this.getOptionName('list')}</dd></dl>
        <h2>New Card</h2>
        <CardForm {...this.props} />
      </React.Fragment>
    );
  }

  renderCards = this.renderCards.bind(this);

  renderCards() {
    const { storage } = this.props;
    return (
      <React.Fragment>
        <h2>Latest Cards</h2>
        <ListGroup>
          {storage.cards.map((card) => (
            <ListGroupItem key={card.id} href={card.shortUrl} target="_blank">
              <b>{card.name}</b> {moment(card.dateLastActivity).fromNow()}
            </ListGroupItem>
          ))}
        </ListGroup>
      </React.Fragment>
    );
  }

  render() {
    const {
      storage, dismiss, onUpdate, status,
    } = this.props;
    if (!storage.token) {
      return <GetToken onSubmit={onUpdate} />;
    }
    const showSelect = !(storage.board && storage.list);
    return (
      <Wrapper>
        {status.alert && <Alert bsStyle="success" onDismiss={dismiss('alert')}>{status.alert}</Alert>}
        {status.error && <Alert bsStyle="danger" onDismiss={dismiss('error')}>{status.error}</Alert>}
        {showSelect ? this.renderSelectBlock() : this.renderFormBlock() }
        {storage.cards && storage.cards.length > 0 && this.renderCards()}
      </Wrapper>
    );
  }
}

Main.propTypes = {
  storage: PropTypes.object,
  options: PropTypes.object,
  status: PropTypes.object,
  dismiss: PropTypes.func,
  onUpdate: PropTypes.func,
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js